export const LOAN_REVIEW_PERMS = ["admin", "los_loan_review"];
export const INSTITUTION_ADMIN_PERMS = ["admin", "institution_admin"];
export const COMMON_DOCS_PERMS = ["common_docs_read"];
export const DOC_PREP_PRIV_PERMS = ["doc_prep_priv"];
export const PPP_MENU_PERMS = ["ppp_read_write", "ppp_read_write_unfiltered"];
